import {common_utils} from "../common/common_utils";

function detail_by_token_esports()
{

}

detail_by_token_esports.readDataValue = function(this1, data)
{
  this1.esports = true
  this1.hasfree = false
  this1.hasbonuswin = false

  // this1.recordId = data.recordId
  // this1.username = data.loginName
  // this1.gameid = data.gameId
  // this1.profit = data.win - data.bet
  // this1.betamount = data.bet
  // this1.betTime = data.startTime
  common_utils.readDataValue(this1,data,true);

  if (data.detail) {
    this1.hashblock = data.detail.BlockHash
    this1.hashbettime = data.detail.BetTimestamp
    this1.hashresulttime = data.detail.DealTimestamp
    this1.hashheight = data.detail.BlockNumber

    if (data.gameId == 6000) {
      this1.hashbettype = data.detail.BetType == '0' ? this1.$t(`lang.str_hash_small`) : this1.$t(
        `lang.str_hash_big`)

      var result = '';
      for (var i = 0; i < data.detail.BlockHash.length; i++) {
        var n = data.detail.BlockHash.charAt(data.detail.BlockHash.length - 1 - i)
        if (!isNaN(n)) {
          result = n
          this1.hashblock_l = data.detail.BlockHash.substring(0, data.detail.BlockHash.length - 1 - i)
          this1.hashblock_v = n
          this1.hashblock_r = data.detail.BlockHash.substring(data.detail.BlockHash.length - i)
          break;
        }
      }
      this1.hashresult = (result < 5 ? this1.$t(`lang.str_hash_small`) : this1.$t(`lang.str_hash_big`))
    }

    if (data.gameId == 6001) {
      this1.hashbettype = data.detail.BetType == '0' ? this1.$t(`lang.str_hash_single`) : this1.$t(
        `lang.str_hash_double`)

      var result = '';
      for (var i = 0; i < data.detail.BlockHash.length; i++) {
        var n = data.detail.BlockHash.charAt(data.detail.BlockHash.length - 1 - i)
        if (!isNaN(n)) {
          result = n
          this1.hashblock_l = data.detail.BlockHash.substring(0, data.detail.BlockHash.length - 1 - i)
          this1.hashblock_v = n
          this1.hashblock_r = data.detail.BlockHash.substring(data.detail.BlockHash.length - i)
          break;
        }
      }
      this1.hashresult = ((result % 2 != 0) ? this1.$t(`lang.str_hash_single`) : this1.$t(
        `lang.str_hash_double`))
    }


    if (data.gameId == 6002) {
      this1.hashbettype = data.detail.BetType == '0' ? this1.$t(`lang.str_hash_zhuang`) : this1.$t(
        `lang.str_hash_xian`)

      var result = '';

      this1.hashblock_l = data.detail.BlockHash.substring(0, data.detail.BlockHash.length - 5)
      this1.hashblock_v = data.detail.BlockHash.substring(data.detail.BlockHash.length - 5)
      this1.hashblock_r = ''

      var z1 = data.detail.BlockHash.charAt(data.detail.BlockHash.length - 1 - 4)
      var z2 = data.detail.BlockHash.charAt(data.detail.BlockHash.length - 1 - 3)
      var n = data.detail.BlockHash.charAt(data.detail.BlockHash.length - 1 - 2)
      var x1 = data.detail.BlockHash.charAt(data.detail.BlockHash.length - 1 - 1)
      var x2 = data.detail.BlockHash.charAt(data.detail.BlockHash.length - 1 - 0)

      z1 = isNaN(z1) ? 10 : z1
      z2 = isNaN(z2) ? 10 : z2
      n = isNaN(n) ? 10 : n
      x1 = isNaN(x1) ? 10 : x1
      x2 = isNaN(x2) ? 10 : x2

      var z = ((Number(z1) + Number(z2) + Number(n)) % 10)
      var x = ((Number(x1) + Number(x2) + Number(n)) % 10)
      z = z == 0 ? 10 : z
      x = x == 0 ? 10 : x
      var result = (z == x ? this1.$t(`lang.str_hash_he`) :
        (z > x ? (this1.$t(`lang.str_hash_zhuang`) + this1.$t(`lang.str_hash_win`)) :
          (this1.$t(`lang.str_hash_xian`) + this1.$t(`lang.str_hash_win`))))

      this1.hashresult =

        this1.$t(`lang.str_hash_zhuang`) + ":" +
        this1.$t(`lang.str_hash_bull`) + (z % 10 == 0 ? this1.$t(`lang.str_hash_bull`) : z) +
        "(" + z1 + "+" + z2 + "+" + n + "=" + (Number(z1) + Number(z2) + Number(n)) + ") <br/>"

        +
        this1.$t(`lang.str_hash_xian`) + ":" +
        this1.$t(`lang.str_hash_bull`) + (x % 10 == 0 ? this1.$t(`lang.str_hash_bull`) : x) +
        "(" + n + "+" + x1 + "+" + x2 + "=" + (Number(x1) + Number(x2) + Number(n)) + ") <br/>"

        +
        result
    }
  }
}
export {
  detail_by_token_esports
};




// WEBPACK FOOTER //
// ./src/components/data/detail_by_token_esports.js